import { render, staticRenderFns } from "./ResultadosWindowLB.vue?vue&type=template&id=7a4bed3c&scoped=true&"
import script from "./ResultadosWindowLB.vue?vue&type=script&lang=js&"
export * from "./ResultadosWindowLB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4bed3c",
  null
  
)

export default component.exports